var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    _vm._b(
      {
        attrs: {
          "invalid-feedback": _vm.invalidFeedback,
          "label-for": _vm.formControlId,
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _vm.label
                  ? [
                      _vm._v(
                        "\n            " + _vm._s(_vm.label) + "\n            "
                      ),
                      _c("csp-form-tooltip", {
                        attrs: { tooltip: _vm.tooltip },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "b-form-group",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _c("csp-form-select-searchable-with-tags", {
        attrs: {
          id: _vm.formControlId,
          "allow-empty": !_vm.isRequiredProperty,
          "auto-select-single-option": _vm.autoSelectSingleOption,
          "disable-change-trigger": _vm.disableChangeTrigger,
          disabled: _vm.isReadOnlyProperty || _vm.dependencyDisabled,
          options: _vm.internalOptions,
          "options-loader": _vm.optionsLoader,
          placeholder: _vm.placeholder,
          property: _vm.property,
          "reset-after": _vm.resetAfter,
          state: _vm.validationState,
          "value-empty": _vm.valueEmpty,
        },
        on: { change: _vm.handleSelect },
        model: {
          value: _vm.data[_vm.property],
          callback: function ($$v) {
            _vm.$set(_vm.data, _vm.property, $$v)
          },
          expression: "data[property]",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }